import { IncrementDecrementArgs } from "../Types/calculator"

export const incrementDecrementArrows = ({ ev, field, step = 1, onlyNumbers = true, currency, percent, state, setSettings, onlyUpDown }: IncrementDecrementArgs) => {
    if (ev.key === "Backspace" || ev.key === "Tab") return
    if (onlyUpDown && ev.key !== "ArrowUp" && ev.key !== "ArrowDown") return
    if (ev.key === "ArrowLeft" || ev.key === "ArrowRight" || ev.key === "ArrowUp" || ev.key === "ArrowDown") {
      const calculatedStep = currency ? 0.1 : step
      const decrement = ev.key === "ArrowLeft" || ev.key === "ArrowDown"
      ev.preventDefault()
      const newValue = (state[field] as number) + (decrement ? -calculatedStep : calculatedStep)
      const newPercentValue = Math.min(1, Math.max(0, (state[field] as number) + (decrement ? -0.01 : 0.01)))
      setSettings({ [field]: percent ? newPercentValue : newValue })
    }
    if (onlyNumbers && !/[0-9.]/.test(ev.key)) ev.preventDefault()
  }